export enum EVIDENCE_TABS {
  EVIDENCE = 'Evidence',
  EXCLUDED = 'Excluded',
  SOURCE = 'Source',
  PROPERTIES = 'Properties',
  CONTROLS = 'Linked Controls',
  REQUESTS = 'Requests',
}
